import React, { Component } from "react";
import Form from "react-validation/build/form";

import {
  renderTextBox,
  renderOptionalTextBox,
  renderDropdown,
  renderOptionalDropdown,
  renderAddDeleteButton,
  renderDate,
  renderAdditionalComments,
  renderFile,
  renderEffectiveDate,
  renderRadioButton,
  renderYesNo,
} from "./RenderUtils";

const maritalStatus = [
  { Name: "Divorced" },
  { Name: "Domestic Partner" },
  { Name: "Married" },
  { Name: "Separated" },
  { Name: "Single" },
  { Name: "Widow" },
];

const driversLicenseStatus = [
  { Name: "Valid U.S. License" },
  { Name: "Canceled" },
  { Name: "Expired" },
  { Name: "International License" },
  { Name: "Not/Never Licensed" },
  { Name: "Revoked" },
  { Name: "Suspended" },
  { Name: "Surrendered" },
  { Name: "Temporary" },
  { Name: "Unknown" },
];

const typeOfSR22Filing = [
  { Name: "Filing responsibility is not needed" },
  { Name: "Filing has not been made and is required" },
  { Name: "Filing has been made" },
];

export class AddDeleteDriverRequest extends Component {
  render() {
    var request = this.props.data;
    var updateRequest = this.props.updateRequest;

    return (
      <Form ref={this.props.formRef}>
        <div>
          {renderEffectiveDate(request, updateRequest)}
          {renderAddDeleteButton("Add/Delete Driver", request, updateRequest)}
          {renderTextBox(
            "driverName",
            "Driver Name",
            request,
            updateRequest,
            "Name of Employee"
          )}
          {renderTextBox(
            "licenseNumber",
            "License Number",
            request,
            updateRequest,
            "License Number"
          )}
          {renderDropdown(
            "licenseState",
            "License State",
            request,
            updateRequest,
            this.props.states
          )}
          {renderDate("dateOfBirth", "Date of Birth", request, updateRequest)}
          <div className="form-group card-holder">
            <label>Gender</label>
            <div>
              {renderRadioButton(
                "gender",
                "Male",
                request,
                updateRequest,
                "Male"
              )}
              {renderRadioButton(
                "gender",
                "Female",
                request,
                updateRequest,
                "Female"
              )}
            </div>
          </div>
          {renderOptionalDropdown(
            "maritalStatus",
            "Marital Status",
            request,
            updateRequest,
            maritalStatus
          )}
          <div className="form-group card-holder">
            <label>Relationship to Insured</label>
            <div>
              {renderRadioButton(
                "relationship",
                "Insured",
                request,
                updateRequest,
                "Insured"
              )}
              {renderRadioButton(
                "relationship",
                "Other",
                request,
                updateRequest,
                "Other"
              )}
              {renderRadioButton(
                "relationship",
                "Spouse",
                request,
                updateRequest,
                "Spouse"
              )}
            </div>
          </div>
          {renderDate("dateLicensed", "Date Licensed", request, updateRequest)}
          {renderOptionalDropdown(
            "licenseStatus",
            "Drivers License Status",
            request,
            updateRequest,
            driversLicenseStatus
          )}
          {renderYesNo(
            "commercialDriversLicense",
            "Has a Commercial Driver's License (CDL)",
            request,
            updateRequest
          )}
          {renderDate(
            "commercialDriversLicenseDate",
            "Commercial Drivers License Date",
            request,
            updateRequest
          )}
          {renderYesNo(
            "requiresSR22Filing",
            "Requires SR-22 Filing",
            request,
            updateRequest
          )}
          {renderOptionalDropdown(
            "TypeOfFiling",
            "SR-22 Type of Filing",
            request,
            updateRequest,
            typeOfSR22Filing
          )}
          {renderOptionalTextBox(
            "caseNumber",
            "SR-22 Case Number",
            request,
            updateRequest,
            "SR-22 Case Number"
          )}
          {renderYesNo(
            "hasViolationsOrAccidents",
            "Has violations or accidents within the last 3 years or DUIs/DWIs within the last 10 years",
            request,
            updateRequest
          )}
          {renderAdditionalComments(updateRequest)}
          {renderFile(request, updateRequest)}
        </div>
      </Form>
    );
  }
}
